export default "__VITE_ASSET__BVtEPrXE__"